import React, { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import InputField from "../commoncomponents/input/InputField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import globalClasses from "../../component/commoncomponents/css/Global.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonComponent from "../commoncomponents/buttons/ButtonComponent";
import { getRequest } from "../../api/AxiosAPICall";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { Backdrop, CircularProgress, IconButton, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SignInLink from "../commoncomponents/link/SignInLink";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../commoncomponents/alert/SnackbarAction";

const theme = createTheme();

const ChangePassword = (props: any) => {
  let history = useNavigate();

  const [forgotData, setForgotData] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isShowPassward, setIsShowPassward] = useState(false);
  const [isShowPasswardConfirm, setIsShowPasswardConfirm] = useState(false);
  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    if (
      location?.state?.userName !== undefined &&
      location?.state?.userName !== null
    ) {
      setForgotData(location?.state?.userName?.userName);
    } else {
      history("/unauthenticatedUser");
    }
  }, [location, history]);

  const resetUserPasswordRecovery = async (values: any) => {
    setIsLoading(true);
    const response = await getRequest("resetUserPasswordRecovery", {
      params: {
        useUsername: forgotData,
        newPassword: values.password,
      },
    });

    setIsLoading(false);
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",

          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else if (response.data === true) {
      dispatch(
        setSnackbar(
          true,
          4000,
          "success",
          "Password Changed Successfully",
          "top",
          "center"
        )
      );
      setTimeout(() => {
        history("/signin");
      }, 1000);
    } else {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Password Not Changed Successfully",
          "top",
          "center"
        )
      );
    }
  };
  return (
    <Formik
      //********Using Yup for validation********/
      initialValues={{ password: "", confirmPassword: "" }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .required("Enter Password")
          .min(8, "Minimum 8 characters.")
          .matches(/[a-zA-Z]/, "At least one letter.")
          .matches(/[@$!%*#?&]+/, "One special character required"),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref("password")], "Passwords do not match")
          .required("Re-enter Password"),
      })}
      onSubmit={() => {}}
    >
      {(data: FormikProps<any>) => {
        return (
          <>
            <form onSubmit={data.handleSubmit}>
              <CommonLayout>
                <ThemeProvider theme={theme}>
                  <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                      sx={{
                        marginTop: 20,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography component="h1" variant="h5" sx={{ mb: -1 }}>
                        Forgot Password?
                      </Typography>
                      <Box sx={{ mt: 1 }} className={globalClasses.boxGrid}>
                        <Typography
                          component="h6"
                          variant="h6"
                          sx={{ fontSize: "15px" }}
                        >
                          Please complete the following form.
                        </Typography>

                        <Typography
                          component="h6"
                          variant="h6"
                          sx={{ fontSize: "15px", mb: 2 }}
                        >
                          Password must be minimum 8-characters long and one
                          special character(Symbol) and should avoid words such
                          as 'password'.
                        </Typography>
                        <Stack spacing={2}>
                          <InputField
                            id="password"
                            name="password"
                            inputvalues={data.values.password}
                            type={isShowPassward ? "text" : "password"}
                            changeevent={data.handleChange}
                            blurevent={data.handleBlur}
                            isrequired={true}
                            errormessage={
                              data.touched.password &&
                              Boolean(data.errors.password)
                            }
                            message={
                              data.touched.password && data.errors.password
                            }
                            label="Password"
                            autoComplete="password"
                            autoFocus
                            customprops={
                              <IconButton
                                onClick={() =>
                                  setIsShowPassward(!isShowPassward)
                                }
                              >
                                {isShowPassward ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            }
                          />
                          <InputField
                            id="confirmPassword"
                            name="confirmPassword"
                            inputvalues={data.values.confirmPassword}
                            type={isShowPasswardConfirm ? "text" : "password"}
                            changeevent={data.handleChange}
                            blurevent={data.handleBlur}
                            isrequired={true}
                            errormessage={
                              data.touched.confirmPassword &&
                              Boolean(data.errors.confirmPassword)
                            }
                            message={
                              data.touched.confirmPassword &&
                              data.errors.confirmPassword
                            }
                            label="Confirm Password"
                            autoComplete="confirmPassword"
                            autoFocus
                            customprops={
                              <IconButton
                                onClick={() =>
                                  setIsShowPasswardConfirm(
                                    !isShowPasswardConfirm
                                  )
                                }
                              >
                                {isShowPasswardConfirm ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            }
                          />
                        </Stack>

                        <ButtonComponent
                          buttonclass={globalClasses.forgotPasswordButton}
                          fullWidth
                          label="Save"
                          onClick={(event: any) => {
                            data.handleSubmit(event);

                            if (
                              data.values.password !== null &&
                              data.values.password !== "" &&
                              data.values.confirmPassword !== null &&
                              data.values.confirmPassword !== "" &&
                              data.errors.password == null &&
                              data.errors.confirmPassword == null
                            ) {
                              resetUserPasswordRecovery(data.values);
                            }
                          }}
                        />
                      </Box>
                      {isLoading && (
                        <Box>
                          <Backdrop open>
                            <CircularProgress
                              className={globalClasses.circularProgress}
                            />
                          </Backdrop>
                        </Box>
                      )}
                      <SignInLink />
                    </Box>
                  </Container>
                </ThemeProvider>
              </CommonLayout>
            </form>
          </>
        );
      }}
    </Formik>
  );
};
export default ChangePassword;
